import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "./Reveal";
import { PHOTO_SIZES, PHOTOS } from "./images";
import { BOOKING_URL, BUSINESS } from "@/lib/site";

export function ContactCTA() {
  const photo = PHOTOS.parkModelPatio;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-28 sm:py-32 lg:py-40"
      aria-labelledby="final-cta-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,oklch(0.259_0.042_163.6/0.82)_0%,oklch(0.259_0.042_163.6/0.92)_100%)]"
        aria-hidden="true"
      />

      <Reveal className="mx-auto max-w-3xl px-4 text-center text-cream sm:px-6">
        <h2
          id="final-cta-title"
          className="text-balance font-display text-3xl leading-tight sm:text-4xl lg:text-[3rem]"
        >
          Your Zapata Stay Starts Here
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg">
          Choose your dates, find the accommodation that fits your trip, and experience the
          welcoming atmosphere of Amigo Inn &amp; RV Park.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Button asChild variant="book" size="ctaLg">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Check Availability <ArrowRight aria-hidden="true" />
            </a>
          </Button>
          <Button asChild variant="outlineLight" size="ctaLg">
            <a href={BUSINESS.phoneHref}>
              <Phone aria-hidden="true" /> Call {BUSINESS.phone}
            </a>
          </Button>
        </div>
      </Reveal>
    </section>
  );
}
